<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Slide Right'"
  [subTitle]="'Other - Animation'"
>
  <app-tabs body [tabs]="tabs" (selectedTabIndex)="selectedTab = $event">
    <h1 @slideRightAnimation *ngIf="selectedTab === 0">Tab 1 Example</h1>
    <h1 @slideRightAnimation *ngIf="selectedTab === 1">Tab 2 Example</h1>
  </app-tabs>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Form Dirty'"
  [subTitle]="'Other - Guards'"
>
  <div body>
    <form class="email-form" [formGroup]="form" (ngSubmit)="submit()">
      <div>
        <div class="name">
          <input type="text" placeholder="Your Name" formControlName="name" />
        </div>
      </div>

      <button>Submit</button>
    </form>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Fade In Out'"
  [subTitle]="'Other - Animation'"
>
  <div body>
    <h2 *ngIf="isInDOM" [@fadeInOutAnimation]>Hello</h2>
    <h2 *ngIf="!isInDOM" [@fadeInOutAnimation]>World</h2>
  </div>

  <div footer>
    <button (click)="isInDOM = !isInDOM">Toggle Animation</button>
  </div>
</app-card>
